import {Apartment} from "features/apartmentViewer/types";
import {CameraModel} from "features/apartmentViewer/ApartmentViewer/models/CameraModel";
import {ThumbNailModel} from "features/apartmentViewer/ApartmentViewer/models/ThumbNailModel";

export class ApartmentModel {
    public version: number;
    public id: string;
    public name: string;
    public type: string;
    public dayOfYear: number;
    public timeInHours: number;
    public offsetUTC: number;
    public latitude: number;
    public longitude: number;
    public minimaps: string[];
    public cameras: CameraModel[];
    public thumbNails: ThumbNailModel[] = [];


    constructor(apartment: Apartment) {
        this.version = apartment.version;
        this.id = apartment.id;
        this.name = apartment.name;
        this.type = apartment.type;
        this.dayOfYear = apartment.dayOfYear;
        this.timeInHours = apartment.timeInHours;
        this.offsetUTC = apartment.offsetUTC;
        this.latitude = apartment.latitude;
        this.longitude = apartment.longitude;
        this.minimaps = apartment.minimaps;
        this.cameras = apartment.cameras.map(camera => new CameraModel(camera));
    }
}
